import React,{useState,useEffect, useRef} from 'react';
import Card from './cardSimulacrum';
import { FaBalanceScale} from 'react-icons/fa';
import {db} from '../../config/firebase';
import dbRef from '../../config/dbRef';
import { collection, getDocs } from "firebase/firestore";
import image from '../../assets/images/logoBlanco.png';
import {Contactanos} from './../components/uiComponents';

export default function Simulacrum(props){
    const [items, setItems] = useState([])
    const [statsVisible, setStatsVisible] = useState(false);
    const divElemento =  useRef(null);

  useEffect(() => {
    const scrollHandler = () => {
      if (divElemento.current && divElemento.current.getBoundingClientRect().top < window.innerHeight - 150) {
        setStatsVisible(true);
      }
    };
    window.addEventListener("scroll", scrollHandler, true);
    scrollHandler();
    return () => {
      window.removeEventListener("scroll", scrollHandler, true);
    };
  }, []);

    useEffect(()=>{
        getDocs(collection(db,dbRef.exam))
        .then((response)=>{
            let examenes =[]
            response.forEach((doc)=>{
              examenes.push(
                {
                  id:doc.id,
                  data:doc.data(),
                }
              );
            });
            return examenes;
        }).then( doc =>{setItems(doc)})
    },[])
    
    const stats = [
      { value: props.clients, label: 'Clientes actuales' },
      { value: items.length, label: 'Exámenes' },
      { value: 7, label: 'Ciudades', hideOnMobile: true },
      { value: `${props.totalPreguntas || 0}+`, label: 'Preguntas', hideOnMobile: true },
    ];

    return(
    <>
        <div  className="bg-white flex flex-col md:flex-row items-center pt-10 pb-8 md:pt-16 md:pb-10" >
          <div className="h-64 w-full md:h-96 md:w-2/5 hidden md:block" style={{backgroundImage:`url(${image})`,backgroundSize:'contain',backgroundRepeat:'no-repeat', backgroundPosition:'center'}}></div>
          <div className="w-full md:w-3/5 px-6 md:px-12 lg:px-16 flex flex-col justify-center text-center md:text-left">
                 <div>
                   <span className='text-primary font-bold text-sm uppercase tracking-widest'>¿Quiénes somos?</span>
                   <div className='font-bold text-2xl md:text-3xl mt-2 text-fondo leading-snug'>Somos un equipo multidisciplinario de profesionales comprometidos con tus resultados</div>
                 </div>
                 <div className="flex flex-col md:flex-row items-center md:items-start pt-6">
                   <div className="bg-primary bg-opacity-10 rounded-full p-4 mb-4 md:mb-0">< FaBalanceScale  className="text-primary text-4xl"/></div>
                   <div  className="px-0 md:px-6">
                    <p className='text-lg text-gray-600'>Apriori: pura preparación, puro poder.</p>
                    <Contactanos type={'fill'} texto={'Contáctanos'} />
                   </div>
                 </div>
          </div>
        </div>
        <div ref={divElemento} className='bg-gray-100 flex flex-row flex-wrap justify-around py-10 px-4'>
          {stats.map((stat) => (
            <div key={stat.label} className={`flex flex-col items-center m-4 ${stat.hideOnMobile ? 'hidden md:flex' : ''}`}>
              <div className={`stat-number font-bold text-5xl text-fondo ${statsVisible ? 'is-visible' : ''}`}>{stat.value}</div>
              <span className="text-gray-500 mt-2 text-sm uppercase tracking-wide">{stat.label}</span>
            </div>
          ))}
        </div>
        <div className="bg-gray-100 pb-16 pt-12 px-6 md:px-12 lg:px-20">
            <div className="landing-wrap">
            <h2 className="text-3xl text-primary font-bold text-center md:text-left">Pruebas disponibles</h2>
            <p className="mt-3 text-base md:text-xl text-gray-600 text-center md:text-left max-w-4xl">Nuestro trabajo está desarrollado por profesionales del área, junto a la última tecnología, para ofrecerte la mejor preparación.</p>
            <div className="flex flex-col items-center mt-8">
                <div className="relative w-full">
                    <div  className="w-full flex flex-wrap justify-center">
                    {
                      items.map((examen,index) => (
                        examen.data.visible?
                          <Card key={examen.id || index} data = {examen} id={examen.id}/>
                          :null
                          )
                      )
                    }
                    </div>
                </div>
            </div>
            </div>
        </div>
    </>
    );
};
